export default __webpack_public_path__ + "static/220803_天下布魔更新內容預告_jp-8e668f6bf2efbb746cfbbdfbe5513e37.png";